// Run when ready

function checkboxAndRadioStyled() {
            
    // Adds element after sibling
    Element.prototype.appendAfter = function(element) {
        element.parentNode.insertBefore(this, element.nextSibling);
    }, false;
    
    var checkBoxRadioStyled = document.querySelectorAll('.checkbox.styled:not(.ready), .radio.styled:not(.ready)');

    if (checkBoxRadioStyled.length){
        for (var i = 0; i < checkBoxRadioStyled.length; i++) {
            checkBoxRadioStyled[i].classList.add('ready');
            
            // Attempt to get input width value from stylesheet
            var checkBoxRadioInput = checkBoxRadioStyled[i].querySelectorAll('input');
            var checkBoxRadioStyle = getComputedStyle(checkBoxRadioInput[0]);
            var checkBoxRadioSizePx = checkBoxRadioStyle.width.split('px');
            var checkBoxRadioType;
            var checkBoxRadioRadius;

            // Check if checkbox or radio
            if (checkBoxRadioInput[0].getAttribute('type') === 'checkbox') {
                checkBoxRadioType = "isCheckbox"
                checkBoxRadioRadius = '2'
            } else if (checkBoxRadioInput[0].getAttribute('type') === 'radio') {
                checkBoxRadioType = "isRadio"
                checkBoxRadioRadius = '100'
            }
            
            // Value we can use for calculating later
            var checkBoxRadioSize = checkBoxRadioSizePx[0];

            // Scale these proportionally to get a pixel perfect-ish checkmark
            // 18*x = 4
            // 18*x = 9
            // 18*x = 8
            // 18*x = 13
            // 18*x = 14
            // 18*x = 5
        
            // Dynamically create checkmark points
            var checkMarkPoints = 
                '' + 
                (checkBoxRadioSize * (4 / 18)).toFixed(5) + 
                ',' + 
                (checkBoxRadioSize * (9 / 18)).toFixed(5) + 
                ' ' + 
                (checkBoxRadioSize * (8 / 18)).toFixed(5) + 
                ',' + 
                (checkBoxRadioSize * (13 / 18)).toFixed(5) + 
                ' ' + 
                (checkBoxRadioSize * (14 / 18)).toFixed(5) + 
                ',' + 
                (checkBoxRadioSize * (5 / 18)).toFixed(5) + 
            '';

            // Dynamically center and size of the checked circle in the radio
            // cx/cy: 18*x = 9
            // r: 18*x = 4.5
            var radioXY = (checkBoxRadioSize * (9 / 18)).toFixed(5);
            var radioRadius = (checkBoxRadioSize * (4.5 / 18)).toFixed(5);
            
            // Dynamic inner svg markup
            var checkBoxRadioSVGInner =
                '<!-- The background -->' +
                '<rect class="styled__bg" width="' + (checkBoxRadioSize - 2) + '" height="' + (checkBoxRadioSize - 2) + '" x="1" y="1" stroke="currentColor" fill="none" stroke-width="2" rx="' + checkBoxRadioRadius + '" ry="' + checkBoxRadioRadius + '"></rect>' +
        
                '<!-- The checkmark-->' +
                '<polyline class="styled__checkmark" points="' + checkMarkPoints + '" stroke="transparent" stroke-width="2" fill="none"></polyline>' +

                '<!-- The radio circle -->' +
                '<circle class="styled__radio" cx="' + radioXY + '" cy="' + radioXY + '" r="' + radioRadius + '"/>';

            // Create SVG
            var checkBoxRadioSVG = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            
            // Add some attributes. Some values are calculated from the input size in the stylesheet
            checkBoxRadioSVG.setAttribute('width', checkBoxRadioSize);
            checkBoxRadioSVG.setAttribute('height', checkBoxRadioSize);
            checkBoxRadioSVG.setAttribute('viewBox', '0 0 ' + checkBoxRadioSize + ' ' + checkBoxRadioSize + '');
            checkBoxRadioSVG.setAttribute('aria-hidden', true);
            checkBoxRadioSVG.setAttribute('focusable', false);
            
            // Insert inner svg markup
            checkBoxRadioSVG.innerHTML = checkBoxRadioSVGInner;

            // Insert customized svg elements after checkbox input
            checkBoxRadioSVG.appendAfter(checkBoxRadioStyled[i].querySelectorAll('input')[0]);
        }
    }
}
window.addEventListener('DOMContentLoaded', checkboxAndRadioStyled, false);